import PropTypes from 'prop-types';
import React from 'react';

import FileDragTarget from 'util/drag-and-drop/FileDragTarget';

function OptionalFileDragTarget({enabled, ...props}) {
  if (!enabled) {
    return React.createElement(props.component, null, props.children);
  }
  return <FileDragTarget {...props}>{props.children}</FileDragTarget>;
}

OptionalFileDragTarget.propTypes = {
  enabled: PropTypes.bool.isRequired,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.instanceOf(React.Component)])
    .isRequired,
  children: PropTypes.node.isRequired,
  finderId: PropTypes.string,
};

export default OptionalFileDragTarget;
